const project = {
    getlist: 'project/getlist',
    add: 'project/add',
    update: 'project/update',
    remove: 'project/remove',
    get: 'project/get',
    getall: 'project/getall',
}
export default project
